module.exports = __webpack_public_path__ + "static/media/login_background_image.857a726c.jpg";